import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region DISCOUNT

function _Discount(props) {
    const hasValue = props.data && props.data.HasDiscount;
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Discount = withLabelTokenParsing(_Discount, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Discount:
            if (data.Discount != undefined) {
                replaceString = Utilities.Format.getDiscountString(data, props.index, props.data && props.data.Gallery && props.data.Gallery.Localization, options);
            }
            break;
        case Token.DisplayCurrency.Discount:
            if (data.DiscountType != 1 && data.ExchangeRate && data.ExchangeRate.Discount != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Discount, options);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const discountToken = Token.getCurrencyTokenConfig('Discount', Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization), Token.Discount);
    discountToken.options.push({ defaultValue: Utilities.Format.Percent.getDefaultFormatString() , display: 'Percent Format', name: 'percentFormat', note: 'Keywords: [Value]', type: 'percentFormat' })
    return [
        discountToken,
        Token.getWrappedTokenConfig('Discount (Display Currency)', Token.DisplayCurrency.Discount)
    ];
};
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Discount' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Discount}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}","percentFormat":"${Utilities.Format.Percent.getDefaultFormatString()}")}`, token: Token.Discount }))
    }
};

// #endregion DISCOUNT

export {
    Discount as Component,
    Tokens,
    TypeConfig
}